import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';

function _window() : any {
  // return the global native browser window object
  return window;
}

@Injectable()
export class WindowRef {

  private _scrolling: boolean = false;
  
  get scrolling() {
    if (this.configSvc.guiSettings.enableDragScrollFix) {
      return this._scrolling;
    } else {
      return false;
    }
  }
  
  set scrolling(value: boolean) {
    if (value) {
      this._scrolling = true;
    } else {
      setTimeout(() => {
        this._scrolling = false;
      }, 100);
    }
  }
  
  get nativeWindow() : any {
    return _window();
  }
  
  constructor(
    private configSvc: ConfigService
  ) {
    
  }
  
}